import Vue from 'vue'
import i18n from "./utils/i18n";
import App from './components/App.vue'
import router from './router'
import store from './store'
import communicator from './api/CommunicatorPlugin'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.min"
import 'vue-awesome/icons/envelope'
import Icon from "vue-awesome/components/Icon"
import Spinner from "./components/utils/Spinner"

Vue.component("Icon", Icon);
Vue.component("Spinner", Spinner);
Vue.use(communicator);

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
